var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_748",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "#1CADE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_748)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    stroke: "#474B5A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.233 12.5455V12.4943C31.2386 11.9517 31.2955 11.5199 31.4034 11.1989C31.5114 10.8778 31.6648 10.6179 31.8636 10.419C32.0625 10.2202 32.3011 10.0369 32.5795 9.86932C32.7472 9.76705 32.8977 9.64631 33.0312 9.5071C33.1648 9.36506 33.2699 9.2017 33.3466 9.01705C33.4261 8.83239 33.4659 8.62784 33.4659 8.40341C33.4659 8.125 33.4006 7.88352 33.2699 7.67898C33.1392 7.47443 32.9645 7.31676 32.7457 7.20597C32.527 7.09517 32.2841 7.03977 32.017 7.03977C31.7841 7.03977 31.5597 7.08807 31.3438 7.18466C31.1278 7.28125 30.9474 7.43324 30.8026 7.64062C30.6577 7.84801 30.5739 8.11932 30.5511 8.45455H29.4773C29.5 7.97159 29.625 7.55824 29.8523 7.21449C30.0824 6.87074 30.3849 6.60795 30.7599 6.42614C31.1378 6.24432 31.5568 6.15341 32.017 6.15341C32.517 6.15341 32.9517 6.25284 33.321 6.4517C33.6932 6.65057 33.9801 6.9233 34.1818 7.26989C34.3864 7.61648 34.4886 8.01136 34.4886 8.45455C34.4886 8.76705 34.4403 9.04972 34.3438 9.30256C34.25 9.5554 34.1136 9.78125 33.9347 9.98011C33.7585 10.179 33.5455 10.3551 33.2955 10.5085C33.0455 10.6648 32.8452 10.8295 32.6946 11.0028C32.544 11.1733 32.4347 11.3764 32.3665 11.6122C32.2983 11.848 32.2614 12.142 32.2557 12.4943V12.5455H31.233ZM31.7784 15.0682C31.5682 15.0682 31.3878 14.9929 31.2372 14.8423C31.0866 14.6918 31.0114 14.5114 31.0114 14.3011C31.0114 14.0909 31.0866 13.9105 31.2372 13.7599C31.3878 13.6094 31.5682 13.5341 31.7784 13.5341C31.9886 13.5341 32.169 13.6094 32.3196 13.7599C32.4702 13.9105 32.5455 14.0909 32.5455 14.3011C32.5455 14.4403 32.5099 14.5682 32.4389 14.6847C32.3707 14.8011 32.2784 14.8949 32.1619 14.9659C32.0483 15.0341 31.9205 15.0682 31.7784 15.0682Z",
    fill: "#474B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.af150b3ce746fce7627561d0ed6b14b3.svg";
export { ForwardRef as ReactComponent };